import createVueApp from '@phoenix/createVueApp';
import { PhxFocus } from '@phx-styleguides/jlc';

document.querySelectorAll('.phoenix-focus-block').forEach((el) => {
  const app = createVueApp();
  app.component('PhxFocus', PhxFocus);
  app.mount(el);
});
